<template>
  <div class="personal-achievement-revision">
    <van-tabs @click="changeTab">
      <van-tab name="day" title="日维度">
        <div class="calendar-selector">
          <div @click="choiceOneDay(-1)">前一天</div>
          <div class="selector" @click="showDatePicker = true">
            {{ currentDate.getTime() | dateFormat('YYYY-mm-dd') }}
            <div class="icon">
              <img src="@/assets/img/icon-calendar.png" alt="" />
            </div>
          </div>
          <div @click="choiceOneDay(1)">后一天</div>
        </div>
      </van-tab>
      <van-tab name="month" title="月维度">
        <div class="calendar-selector">
          <div @click="choiceOneMonth(-1)">前一月</div>
          <div class="selector" @click="showMonthPicker = true">
            {{ currentMonth.getTime() | dateFormat('YYYY-mm') }}
            <div class="icon">
              <img src="@/assets/img/icon-calendar.png" alt="" />
            </div>
          </div>
          <div @click="choiceOneMonth(1)">后一月</div>
        </div>
      </van-tab>
      <van-tab name="merchant" title="累计商户"></van-tab>
    </van-tabs>

    <div class="newly-added-merchant" v-if="tabName == 'merchant'">
      <div>累计商户数（户）</div>
      <div class="details">
        <div v-for="(item, index) in merCount" :key="index">
          <div>{{ item.desc || '' }}</div>
          <div>{{ item.count || 0 }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="newly-added-merchant">
        <div>新增商户数（户）</div>
        <div class="details">
          <div v-for="(item, index) in activeObj" :key="index">
            <div>{{ item.remark || '' }}</div>
            <div>{{ item.allCount || 0 }}</div>
          </div>
        </div>
      </div>
      <transaction-data
        :buTypeList="buTypeList"
        :tradeObj="tradeObj"
        :showAllMoney="false"
      ></transaction-data>
    </div>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="onConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
    <van-popup v-model="showMonthPicker" position="bottom">
      <van-datetime-picker
        v-model="currentMonth"
        type="year-month"
        title="选择年月"
        :min-date="minMonth"
        :max-date="maxMonth"
        :formatter="formatter"
        @confirm="onConfirm"
        @cancel="showMonthPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { formatMoney, dateFormat } from '@/utils/utils'
import transactionData from '@/views/biz-components/transaction-data.vue'
import {
  getDataPartnerDay,
  getDataPartnerMonth
} from '@/api/achievement/partner'
import { getCumulative } from '@/api/common'
export default {
  components: {
    transactionData
  },
  filters: {
    formatMoney,
    dateFormat
  },
  data() {
    return {
      tabName: 'day',
      showDatePicker: false,
      minDate: new Date(2021, 7, 23),
      maxDate: new Date(),
      currentDate: new Date(),
      showMonthPicker: false,
      minMonth: new Date(2021, 8, 1),
      maxMonth: new Date(),
      currentMonth: new Date(),
      activeObj: {},
      tradeObj: {},
      partnerObj: {},
      buTypeList: [],
      debounceTimer: null,
      isFirst: true,
      merCount: [] // 累计商户数
    }
  },
  created() {
    let url
    if (process.env.NODE_ENV === 'production') {
      url = 'http://wshbblend.worthagent.com.cn/#/partner-achievement/'
    } else {
      url =
        'http://hybrid-h5.qianziworth.cn/worthpay/partner/#/partner-achievement'
    }
    SyHybridSdk.setNavRightBtn({
      params: {
        isShow: 1,
        label: '历史数据',
        func() {
          SyHybridSdk.openWebView({
            params: {
              url: url,
              style: '1',
              orientation: '2'
            },
            success: res => {}
          })
        }
      },
      success: res => {}
    })
    this.currentMonth = new Date(this.getCurrMonth())
    this.maxMonth = this.currentMonth
    this.queryList()
  },
  methods: {
    queryList() {
      if (this.tabName === 'day') {
        getDataPartnerDay({
          payDate: dateFormat(this.currentDate.getTime(), 'YYYY-mm-dd')
        }).then(res => {
          this.activeObj = res.active || {}
          this.tradeObj = res.trade || {}
          this.partnerObj = res.partner || {}
          this.buTypeList = res.buTypeList || []
          console.log(res)
        })
      } else if (this.tabName === 'month') {
        getDataPartnerMonth({
          month: dateFormat(this.currentMonth.getTime(), 'YYYY-mm')
        }).then(res => {
          this.activeObj = res.active || {}
          this.tradeObj = res.trade || {}
          this.partnerObj = res.partner || {}
          this.buTypeList = res.buTypeList || []
          console.log(res)
        })
      } else if (this.tabName === 'merchant') {
        getCumulative({
          type: 2
        }).then(res => {
          this.merCount = res
          console.log(res)
        })
      }
    },
    changeTab(e) {
      scrollTo(0, 0)
      this.tabName = e
      this.isFirst = true
      this.finished = false
      this.queryList()
    },
    onRefresh() {
      this.isFirst = true
      this.finished = false
      this.queryList()
      setTimeout(() => {
        this.refreshing = false
      }, 1000)
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    choiceOneDay(flag) {
      let currentStamp = this.currentDate.getTime()
      const oneDayStamp = 60 * 60 * 24 * 1000
      currentStamp = currentStamp + flag * oneDayStamp
      if (currentStamp > new Date().getTime()) {
        return
      }
      if (currentStamp < new Date('2021-08-23').getTime()) {
        return
      }
      this.currentDate = new Date(currentStamp)
      if (this.isFirst) {
        // 首次
        this.isFirst = false
        if (this.firstTimer) {
          clearTimeout(this.firstTimer)
          this.firstTimer = null
        } else {
          if (!this.debounceTimer) {
            this.firstTimer = setTimeout(() => {
              this.isFirst = true
              clearTimeout(this.firstTimer)
              this.firstTimer = null
            }, 500)
          }
        }
        this.queryList()
        return
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = null
      }
      this.debounceTimer = setTimeout(() => {
        this.queryList()
        clearTimeout(this.debounceTimer)
        this.debounceTimer = null
        this.isFirst = true
      }, 500)
    },
    choiceOneMonth(flag) {
      let thatMonth = this.getOneMonth(this.currentMonth.getTime(), flag)
      let thatMonthStamp = new Date(thatMonth).getTime()
      if (thatMonthStamp < new Date('2021-09-01').getTime()) {
        return
      }
      let currMonth = this.getCurrMonth()
      if (thatMonthStamp > new Date(currMonth).getTime()) {
        return
      }
      this.currentMonth = new Date(thatMonth)
      if (this.isFirst) {
        // 首次
        this.isFirst = false
        if (this.firstTimer) {
          clearTimeout(this.firstTimer)
          this.firstTimer = null
        } else {
          if (!this.debounceTimer) {
            this.firstTimer = setTimeout(() => {
              this.isFirst = true
              clearTimeout(this.firstTimer)
              this.firstTimer = null
            }, 500)
          }
        }
        this.queryList()
        return
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = null
      }
      this.debounceTimer = setTimeout(() => {
        this.queryList()
        clearTimeout(this.debounceTimer)
        this.debounceTimer = null
        this.isFirst = true
      }, 500)
    },
    getOneMonth(stamp, flag) {
      let date = new Date(stamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let result
      if (month + flag == 0) {
        year -= 1
        month = 12
        result = `${year}-${month < 10 ? '0' + month : month}`
      } else if (month + flag == 13) {
        year += 1
        month = 1
        result = `${year}-${month < 10 ? '0' + month : month}`
      } else {
        month += flag
        result = `${year}-${month < 10 ? '0' + month : month}`
      }
      return result
    },
    getCurrMonth() {
      const dateStamp = new Date().getTime()
      return dateFormat(dateStamp, 'YYYY-mm')
    },
    onConfirm(e) {
      if (this.tabName === 'day') {
        this.currentDate = e
      } else {
        this.currentMonth = e
      }
      this.showDatePicker = false
      this.showMonthPicker = false
      this.queryList()
    }
  }
}
</script>
